export const colorPalette = {
  WHITE: 0xffffff,
  LIGHT_CREAM: 0xfffff7,
  LIGHT_YELLOW: 0xffccaa,
  PANTONE_BLUE_2020: 0x0f4c81,
  NIGHT_OWL_BLUE: 0x000c1d
};

export const fftSize = 1024;

export const fogDensity = 0.0005;
